
      var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgEditSubscriberIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 81,
  height: 80,
  viewBox: "0 0 120 120",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18.1 96.891a2.2 2.2 0 1 0 3.8 2.22l-1.9-1.11-1.9-1.11Zm80 2.221a2.2 2.2 0 1 0 3.799-2.22L100 98.002l-1.9 1.11ZM86.183 60.464a2.2 2.2 0 1 0-4.02-1.787l2.01.893 2.01.894ZM63.353 25.43a2.2 2.2 0 1 0 .599-4.36l-.3 2.18-.299 2.18ZM20 98l1.9 1.11C29.754 85.67 44.273 77.378 60 77.378v-4.4c-17.273 0-33.247 9.107-41.9 23.913l1.9 1.11Zm40-22.823v2.2c15.726 0 30.246 8.292 38.1 21.734l1.9-1.11 1.899-1.11C93.247 82.086 77.273 72.978 60 72.978v2.2ZM84.173 59.57l-2.01-.893c-5.018 11.288-17.929 16.965-29.798 13.05l-.69 2.09-.688 2.089c13.987 4.613 29.248-2.06 35.196-15.442l-2.01-.894ZM51.676 73.816l.689-2.09C40.504 67.816 33.64 55.633 36.48 43.642l-2.14-.507-2.141-.507c-3.375 14.247 4.79 28.662 18.786 33.279l.69-2.09ZM34.34 43.134l2.14.507c2.842-11.997 14.477-19.913 26.872-18.211l.3-2.18.299-2.18c-14.603-2.004-28.38 7.317-31.752 21.557l2.14.507Z",
  fill: "#000"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M78.79 47.877h-7.161c-.66 0-1.194-.534-1.194-1.193v-6.666c0-.316.126-.62.35-.844l17.9-17.9a1.193 1.193 0 0 1 1.688 0l6.666 6.666a1.193 1.193 0 0 1 0 1.687l-18.25 18.25Z",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 4.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "m83.943 26.016 8.354 8.353",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 4.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

      const __svgRaw = "<svg width=\"81\" height=\"80\" viewBox=\"0 0 120 120\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path d=\"M18.1006 96.8914C17.4875 97.9404 17.841 99.2878 18.89 99.9008C19.939 100.514 21.2864 100.16 21.8994 99.1114L20 98.0014L18.1006 96.8914ZM98.1005 99.1122C98.7136 100.161 100.061 100.515 101.11 99.9017C102.159 99.2886 102.512 97.9413 101.899 96.8922L100 98.0022L98.1005 99.1122ZM86.1829 60.4638C86.6764 59.3535 86.1764 58.0534 85.0662 57.5599C83.9559 57.0664 82.6557 57.5664 82.1622 58.6767L84.1726 59.5702L86.1829 60.4638ZM63.3531 25.4299C64.5569 25.5952 65.6667 24.7534 65.832 23.5496C65.9972 22.3459 65.1554 21.2361 63.9517 21.0708L63.6524 23.2504L63.3531 25.4299ZM20 98.0014L21.8994 99.1114C29.7546 85.6698 44.2743 77.3781 60.0002 77.3782L60.0002 75.1782L60.0003 72.9782C42.7273 72.978 26.7531 82.0854 18.1006 96.8914L20 98.0014ZM60.0002 75.1782L60.0002 77.3782C75.7261 77.3784 90.2456 85.6704 98.1005 99.1122L100 98.0022L101.899 96.8922C93.2473 82.086 77.2732 72.9784 60.0003 72.9782L60.0002 75.1782ZM84.1726 59.5702L82.1622 58.6767C77.1446 69.9654 64.2342 75.6418 52.3647 71.7269L51.6756 73.8162L50.9865 75.9055C64.9739 80.519 80.2349 73.8457 86.1829 60.4638L84.1726 59.5702ZM51.6756 73.8162L52.3647 71.7269C40.5037 67.8148 33.6415 55.6319 36.4815 43.6413L34.3408 43.1342L32.2 42.6272C28.8255 56.8743 36.9907 71.2893 50.9865 75.9055L51.6756 73.8162ZM34.3408 43.1342L36.4815 43.6413C39.3232 31.6437 50.9575 23.7279 63.3531 25.4299L63.6524 23.2504L63.9517 21.0708C49.3486 19.0657 35.5728 28.387 32.2 42.6272L34.3408 43.1342Z\" fill=\"#000000\"/>\r\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M78.7891 47.8773H71.6289C70.9698 47.8773 70.4355 47.343 70.4355 46.6839V40.0181C70.4355 39.7016 70.5613 39.398 70.7851 39.1742L88.6855 21.2738C89.1515 20.8078 89.9071 20.8078 90.3731 21.2738L97.039 27.9397C97.505 28.4057 97.505 29.1613 97.039 29.6274L78.7891 47.8773Z\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"4.4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n<path d=\"M83.9434 26.0159L92.2969 34.3694\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"4.4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/editSubscriberIcon.049a960757ff160a4a7fcc682eb32c22.svg"),
        {
          React: SvgEditSubscriberIcon,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      